import EventsApi from "../../../api/events-api";
import i18n from "../../../plugins/i18n";
import { EventTypes } from "../../../constants/event_types";

export default {
  name: "AddEventModal",
  props: { cow: Object, isModalOpen: Boolean, reload: Function },
  data() {
    return {
      date: this.$moment(),
      maxDate: this.$moment(),
      notes: null,
      serverError: null,

      selectedEventType: null,
      eventTypes: [
        {
          value: EventTypes.MoveToRepro,
          text: i18n.t(`cowGenerics.cowLogs.${EventTypes.MoveToRepro}`),
          additionalInfo: i18n.t(
            "addEvent.additionalInfo.willChangeCowStatusToRepro"
          )
        },
        {
          value: EventTypes.MoveToVWP,
          text: i18n.t(`cowGenerics.cowLogs.${EventTypes.MoveToVWP}`),
          additionalInfo: i18n.t(
            "addEvent.additionalInfo.willChangeCowStatusToVWP"
          )
        },
        {
          value: EventTypes.Insemination,
          text: i18n.t(`cowGenerics.cowLogs.${EventTypes.Insemination}`),
          additionalInfo: i18n.t(
            "addEvent.additionalInfo.willAddConfirmedInsemination"
          )
        },
        {
          value: EventTypes.Pregnant,
          text: i18n.t(`cowGenerics.cowLogs.${EventTypes.Pregnant}`),
        },
        {
          value: EventTypes.NotPregnant,
          text: i18n.t(`cowGenerics.cowLogs.${EventTypes.NotPregnant}`),
        },
        {
          value: EventTypes.DryingOff,
          text: i18n.t(`cowGenerics.cowLogs.${EventTypes.DryingOff}`),
          additionalInfo: i18n.t(
            "addEvent.additionalInfo.willAddConfirmedDryingOff"
          )
        },
        {
          value: EventTypes.Calving,
          text: i18n.t(`cowGenerics.cowLogs.${EventTypes.Calving}`),
          additionalInfo: i18n.t(
            "addEvent.additionalInfo.willAddConfirmedCalving"
          )
        },
        {
          value: EventTypes.Culled,
          text: i18n.t(`cowGenerics.cowLogs.${EventTypes.Culled}`),
          additionalInfo: i18n.t(
            "addEvent.additionalInfo.willChangeCowStatusToCull"
          )
        }
      ],
      errors: {}
    };
  },
  methods: {
    flushErrors() {
      this.errors = {};
    },
    setDate() {
      this.date = this.$moment();
    },
    validate() {
      this.flushErrors();
      if (!this.date) {
        this.errors.selectType = i18n.t("addEvent.errors.dateNeeded");
      }

      if (this.selectedEventType === null) {
        this.errors.selectType = i18n.t("addEvent.errors.eventNeeded");
      }
      
      if (this.$refs.eventTimePicker.error) {
        return false;
      }

      if (Object.keys(this.errors).length > 0) {
        return false;
      }

      return true;
    },
    async save() {
      // Validate form data before save
      const isValidForm = this.validate();
      if (!isValidForm) return;

      const dataToSend = {
        cow_id: this.cow.cow_id,
        event_type: this.selectedEventType.value,
        event_time: this.$moment(this.date).format(),
        notes: (this.notes && this.notes !== "") ? this.notes : undefined
      }

      // Set loading and wait for data to be sent and response to be returned.
      const response = await EventsApi.post(dataToSend);

      if (response.status === 200) {
        this.reload();
        this.close();
      } else if (response.status === 400) {
        // Failed: Invalid request
        if (typeof response.data === 'object' && response.data.code) {
          // Structured error response with code
          let errorMessage = this.$t(`serverErrors.${response.status}.${response.data.code}`);
          
          // Check if translation was found (if it returns the key, translation was missing)
          if (errorMessage === `serverErrors.${response.status}.${response.data.code}`) {
            // Fallback to the message from the server
            errorMessage = response.data.message || `Error code: ${response.data.code}`;
          }
          
          // Handle parameter substitution for % symbol
          if (response.data.params && response.data.params.length > 0) {
            // Replace each % with corresponding parameter
            response.data.params.forEach((param, index) => {
              errorMessage = errorMessage.replace('%', param);
            });
          }
          
          this.serverError = {
            error: 'Bad request',
            message: errorMessage
          };
        } else if (typeof response.data === 'object') {
          // swagger error (unreadable)
          this.serverError = {
            error: 'Bad request',
            message: 'Invalid url'
          };
        } else {
          this.serverError = {
            error: 'Bad request',
            message: response.data
          };
        }

      } else {
        // Failed: server error
        this.serverError = {
          error: 'An error occured',
          message: 'Something went wrong'
        }
      }
    },
    close() {
      this.$emit("close");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/_modals/add-event/add-event-modal.js